


<div *ngIf="!_remote">Presencial</div>
<div *ngIf="_remote && !_url">Remoto</div>

<div *ngIf="_remote && _url">
    <ejs-tooltip id='tooltip' content='{{startEndText}}' target="#access-{{id}}">
        <button ejs-button cssClass="e-flat" id="access-{{id}}"
            (click)="goToUrl()" iconCss="far fa-external-link" type="button" [isPrimary]="false" iconPosition="Right">Remoto</button>
    </ejs-tooltip>
</div>
